import {GRAPH_DATA} from 'src/app/_interfaces/orderDetail.interface'

export const parseSafeNumber = (value: any): number => {
  if (value === null || value === undefined || value === '') return 0
  
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  
  if (typeof value === 'string') {
    const cleanString = value.replace(/,/g, '').trim()
    const parsed = Number(cleanString)
    return Number.isFinite(parsed) ? parsed : 0
  }
  
  return 0
}

export const sumOrdersFromGraphData = (graphData: GRAPH_DATA[]): number => {
  return (graphData || []).reduce((sum, item) => {
    if (!item?.orders) return sum
    const orders = item.orders as Record<string, any>
    const value = orders.total_orders ?? orders.orders ?? orders.synced ?? 0
    return sum + parseSafeNumber(value)
  }, 0)
}

export const calcPercentChange = (current: number, previous: number): number | null => {
  if (previous === 0) {
    return current === 0 ? 0 : null
  }
  return ((current - previous) / previous) * 100
}
